import PropTypes from 'prop-types';

const propDefs = {
	defaults: {
		vehicle: {},
		displayAttrsList: [
			'type',
			'year',
			'make',
			'model',
			'trim',
			'bodyStyle',
			'vin',
			'modelCode',
			'stockNumber',
			'customTitle'
		],
		deviceType: ''
	},

	settings: {
		vehicle: PropTypes.shape({
			type: PropTypes.string,
			year: PropTypes.number,
			make: PropTypes.string,
			model: PropTypes.string,
			trim: PropTypes.string,
			bodyStyle: PropTypes.string,
			vin: PropTypes.string,
			modelCode: PropTypes.string,
			stockNumber: PropTypes.string,
			customTitle: PropTypes.string,
			certified: PropTypes.bool
		}),
		deviceType: PropTypes.string,
		prefs: PropTypes.shape({
			usedVehicleTerm: PropTypes.string,
			titleDetailsSize: PropTypes.string,
			titleDetailsColor: PropTypes.string,
			titleHeading: PropTypes.string,
			titleHeadingColor: PropTypes.string,
			titleHeadingWeight: PropTypes.string,
			titleHeadingSize: PropTypes.string,
			titleHeadingTagLineWeight: PropTypes.string,
			titleHeadingTagLineSize: PropTypes.string
		}),
		displayAttrsList: PropTypes.arrayOf(PropTypes.string)
	},

	labels: PropTypes.shape({})
};

export default propDefs;



// WEBPACK FOOTER //
// ./src/proptypes/index.js